<template>
  <ValidationObserver ref="observer">
    <v-form @submit="handleRegisterCustomer">
      <v-container>
        <v-row>
          <v-col class="py-0" cols="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Apellido paterno"
              :rules="fathersNameRequired"
            >
              <TextInput
                name="fathersName"
                label="Apellido paterno"
                type="text"
                outlined
                dense
                v-model="form.fathersName"
                :error-messages="errors"
                :max-length="50"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="py-0" cols="6">
            <ValidationProvider
              v-slot="{ errors }"
              name="Apellido materno"
              :rules="mothersNameRequired"
            >
              <TextInput
                name="mothersName"
                label="Apellido materno"
                type="text"
                outlined
                dense
                v-model="form.mothersName"
                :error-messages="errors"
                :max-length="50"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="py-0" cols="12">
            <ValidationProvider
              v-slot="{ errors }"
              name="Nombres"
              :rules="`required`"
            >
              <TextInput
                name="firstName"
                label="Nombres"
                type="text"
                outlined
                dense
                v-model="form.firstName"
                :error-messages="errors"
                :max-length="150"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="py-0" cols="12">
            <ValidationProvider
              v-slot="{ errors }"
              name="email"
              :rules="`email`"
            >
              <TextInput
                name="email"
                label="Correo electrónico"
                type="text"
                outlined
                dense
                v-model="form.email"
                :error-messages="errors"
                :max-length="50"
              />
            </ValidationProvider>
          </v-col>
          <v-col class="py-0" cols="12">
            <ValidationProvider
              v-slot="{ errors }"
              name="Celular"
              :rules="`numeric|min:9`"
            >
              <TextInput
                name="cellPhone"
                label="Celular"
                type="text"
                outlined
                dense
                v-model="form.cellPhone"
                :error-messages="errors"
                :max-length="9"
              />
            </ValidationProvider>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <BasicButton
              cols="12"
              color="secondary"
              text="Cancelar"
              @click="cancelRegisterCustomer"
            />
          </v-col>
          <v-col>
            <BasicButton
              cols="12"
              color="primary"
              type="submit"
              :loading="loading"
              text="Registrar"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </ValidationObserver>
</template>

<script>
import TextInput from '@/infrastructure/vue/components/common/inputs/TextInput';
import BasicButton from '@/infrastructure/vue/components/common/buttons/BasicButton';
import { required, numeric, min, email } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationProvider,
  ValidationObserver,
  setInteractionMode,
} from 'vee-validate';

setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'El campo {_field_} es obligatorio',
});
extend('email', {
  ...email,
  message: 'El correo no es válido',
});
extend('numeric', {
  ...numeric,
  message: 'El campo {_field_} solo debe contener números',
});
extend('min', {
  ...min,
  message: 'El campo {_field_} debe contener mínimo {length} caracteres',
});
export default {
  name: 'NonCustomerRecordForm',
  components: {
    TextInput,
    BasicButton,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    fathersNameRequired: {
      type: String,
      default: 'required',
    },
    mothersNameRequired: {
      type: String,
      default: 'required',
    },
  },
  data: () => ({
    form: {
      fathersName: '',
      mothersName: '',
      firstName: '',
      email: '',
      cellPhone: '',
    },
  }),
  methods: {
    async handleRegisterCustomer(e) {
      e.preventDefault();
      const isValidateForm = await this.$refs.observer.validate();
      if (isValidateForm) {
        this.$emit('onRegisterCustomer', this.form);
      }
    },
    async cancelRegisterCustomer() {
      this.$emit('onCancelRegisterCustomer');
    },
    resetForm() {
      this.form = {
        fathersName: '',
        mothersName: '',
        firstName: '',
        email: '',
        cellPhone: '',
      };
    },
  },
};
</script>

<style></style>
